import React from "react";
import Icon from "./Icon";
import { formatEnglishDate } from "../../utils/dateFormatting";
import "./certification.css";

const categoryConfig = {
  COMPLIANCE: { icon: "shield-check", color: "#3B82F6" },
  SUSTAINABILITY: { icon: "leaf", color: "#10B981" },
  SOCIAL: { icon: "users", color: "#F97316" },
  GOVERNANCE: { icon: "building", color: "#8B5CF6" },
};

const BadgesGrid = ({ badges, columns, showDescription = false }) => {
  const gridStyle = columns ? { gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` } : undefined;
  if (!badges) {
    return (
      <div className="cert-badges-grid" style={gridStyle}>
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="cert-badge-card cert-skeleton" style={{ animationDelay: `${index * 0.1}s` }}>
            <div className="cert-badge-icon" />
            <div style={{ height: 14, marginBottom: 10 }} />
            <div style={{ height: 12, width: "70%", margin: "0 auto" }} />
          </div>
        ))}
      </div>
    );
  }

  if (badges.length === 0) {
    return <div className="cert-empty">No badges earned</div>;
  }

  return (
    <div className="cert-badges-grid" style={gridStyle}>
      {badges.map((badge, index) => {
        const config = categoryConfig[badge.category] || categoryConfig.COMPLIANCE;
        return (
          <div
            key={badge.badgeId || `${badge.name}-${index}`}
            className="cert-badge-card"
            style={{ animationDelay: `${index * 0.1}s`, borderColor: config.color }}
          >
            <div className="cert-badge-icon" style={{ color: config.color }}>
              <Icon name={config.icon} size={44} color={config.color} />
            </div>
            <div className="cert-badge-name">{badge.name}</div>
            {showDescription && <div className="cert-badge-description">{badge.description}</div>}
            <div className="cert-badge-date">Obtained on {formatEnglishDate(badge.earnedAt)}</div>
          </div>
        );
      })}
    </div>
  );
};

export default BadgesGrid;
